export const semanticTokens = {
  colors: {
    'chakra-body-text': { _light: 'primary.800', _dark: 'whiteAlpha.900' },
    'chakra-body-bg': { _light: 'white', _dark: 'gray.800' },
    'chakra-border-color': { _light: 'neutral.200', _dark: 'whiteAlpha.300' },
    'chakra-placeholder-color': {
      _light: 'neutral.200',
      _dark: 'whiteAlpha.400',
    },
    // Badge
    'badge-bg': { default: 'primary.500' },
    // Checkbox
    'checkbox-color': { default: 'primary.800' },
    'checkbox-border': { default: 'primary.500' },
    'checkbox-border-checked': { default: 'white' },
    'checkbox-shadow-color': { default: 'primary.700' },
    'checkbox-shadow-highlight-color': { default: 'primary.500' },
    // Dashboard
    'dashboard-header-bg': { default: 'primary.800' },
    // Form control
    'form-helper-text-color': { default: 'primary.800' },
    // Heading
    'heading-color': { default: 'primary.800' },
    // Input
    'input-bg': 'neutral.50',
    'input-border': 'primary.500',
    'input-focused-border': 'primary.500',
    'input-color': 'primary.800',
    // Label
    'label-color': 'primary.800',
    // Menu
    'menu-item-color': 'primary.800',
    // Select
    'select-bg': 'neutral.50',
    'select-border': 'primary.500',
    'select-color': 'primary.800',
    'select-icon-color': 'primary.500',
    // Text
    'text-color': 'primary.800',

    // Components
    // Steps
    'steps-container-bg': 'primary.800',
    'step-bg': 'primary.100',
    'step-number-border': 'primary.100',
    'step-number-bg': 'transparent',
    'step-number-color': 'primary.100',
    'step-number-passed-bg': 'primary.100',
    'step-number-passed-color': 'primary.800',
    'step-divider-bg': 'primary.600',
    // Steps progress
    'step-progress-passed-bg': 'primary.500',
    // Insurance Info Form Control
    'insurance-info-label-color': 'primary.100',
    'insurance-info-label-bg': 'primary.100',
    'insurance-info-value-color': 'primary.200',
    // Insurance Value
    'insurance-value-border': 'primary.300',
    // Wizzard header
    'wizzard-header-bg': 'primary.800',
    'wizzard-header-gap-bg': 'gray.200',
    'wizzard-header-history-timeline-dot-bg': 'primary.300',
    'wizzard-header-history-timeline-line-bg': 'primary.700',
    'wizzard-header-history-timeline-label-color': 'primary.200',
    'wizzard-header-history-timeline-user-color': 'primary.300',
    'wizzard-header-history-timeline-description-color': 'primary.200',
    'wizzard-header-history-scrollbar-thumb-color': 'primary.800',
    'wizzard-header-history-scrollbar-track-color': 'primary.600',
    'step-current-bg': 'green.500',

    // News
    'news-timeline-info-bg': 'primary.100',
    'news-timeline-info-fg': 'primary.600',
    'news-timeline-warn-bg': 'orange.200',
    'news-timeline-warn-fg': 'orange.600',
    'news-timeline-crit-bg': 'red.200',
    'news-timeline-crit-fg': 'red.700',

    // Stats
    'stats-conversion-color': 'green.500',

    // Login
    'login-bg': 'primary.800',
    'login-button-bg': 'primary.800',
    'login-button-bg-hover': 'green.500'
  },
}
